export default __webpack_public_path__ + "static/media/InfoFilled.72502467.svg";